module.exports = __webpack_public_path__ + "img/inference-case.d05d074f.jpg";